import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { ToolActivationModal } from './ToolActivationModal';
import { Sparkles, Route, Target } from 'lucide-react';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const FunnelXModal: React.FC<Props> = ({ open, onOpenChange }) => {
  useLanguage();
  return (
    <ToolActivationModal
      open={open}
      onOpenChange={onOpenChange}
      toolName="FunnelX"
      toolColor="#2563EB"
      headline={translateInterfaceText("Construa funil de vendas em minutos")}
      subheadline={translateInterfaceText("Crie funis interativos de vendas para todos os nichos.")}
      benefitsTitle={translateInterfaceText("O que você ganha com a FunnelX")}
      benefits={[
        {
          icon: Sparkles,
          text: translateInterfaceText("Construa funil de vendas em minutos"),
          description: translateInterfaceText("Crie funis interativos de vendas para todos os nichos."),
        },
        {
          icon: Route,
          text: translateInterfaceText("Gestão de leads integrada ao funil"),
          description: translateInterfaceText("Acompanhe cada lead em um pipeline visual com histórico completo."),
        },
        {
          icon: Target,
          text: translateInterfaceText("Analytics por etapa e evento"),
          description: translateInterfaceText("Entenda onde seu funil converte, onde perde leads e o impacto em cada campanha."),
        },
      ]}
      formTitle={translateInterfaceText("Seu acesso está quase pronto")}
      formDescription={translateInterfaceText("Confira seus dados e crie sua senha para liberar sua conta.")}
      planBadge={translateInterfaceText("Plano gratuito")}
      planText={translateInterfaceText("Comece testando a FunnelX gratuitamente e conheça a experiência antes de avançar para recursos mais avançados.")}
      successTitle={translateInterfaceText("Sua conta na FunnelX foi criada com sucesso")}
      successText={translateInterfaceText("Seu acesso já está liberado para criar quizzes, testar jornadas e explorar a ferramenta.")}
      successCta={translateInterfaceText("Acessar FunnelX")}
      onAccessTool={() => window.open('https://funnelx.com.br', '_blank')}
      loginUrl="https://funnelx.com.br/login"
    />
  );
};
